<template>
<button
    class="button-link"
    :style="{ color: fg }"
    @click="$emit('click')"
    >
    <slot>{{ label }}</slot>
    <div class="button-link-underline" :style="underlineStyle"></div>
</button>
</template>

<script>
export default {
  name: 'button-link',
  props: {
    label: String,
    // style
    fg: String,
  },
  computed: {
    underlineStyle () {
      return {
        backgroundColor: this.fg,
      }
    }
  },
}
</script>

<style lang="scss">
.button-link {
  font-family: 'regina_blacksolid', serif;
  display: inline-block;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  font-size: inherit;
  position: relative;

  padding: 5px;

  &:focus {
    outline: none;
    background: rgba(255,255,255,0.3);
    .button-link-underline {
      opacity: 0.75;
    }
  }
}
.button-link-underline {
  position: absolute;
  display: block;
  //width: 100%;
  height: 3px;
  background: rgb(0,0,0);
  opacity: 0.5;
  bottom: 0px;
  left: 0px;
  right: 0px;
}
</style>
